import React from 'react';
import { v4 as uuid } from 'uuid';

import { Carousel, FormWrapper } from '../../../WidgetConfiguratorComponents/FormGroups';
import { HorizontalLine } from '../types';
import HorizontalLineComponent from './HorizontalLine';
import { WidgetConfiguratorProps } from './WidgetConfigurator';

const HorizontalLineConfigurator: React.FC<WidgetConfiguratorProps> = ({ viewblockState, setViewblockState }) => {
    const addItem = () => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                horizontalLines: [
                    ...(prev.settings.horizontalLines || []),
                    {
                        id: uuid(),
                        stroke: 'red',
                        lineStyle: 'line',
                        y: 2,
                        yValueVisible: true,
                    },
                ],
            },
        }));
    };

    const updateLine = (updatedLine: HorizontalLine) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                horizontalLines: (prev.settings.horizontalLines || []).map((horizontalLine) =>
                    horizontalLine.id === updatedLine.id ? updatedLine : horizontalLine
                ),
            },
        }));
    };

    const onDelete = (id: string) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                horizontalLines: (prev.settings.horizontalLines || []).filter((horizontalLine) => horizontalLine.id !== id),
            },
        }));
    };

    return (
        <FormWrapper>
            <Carousel label='Items' addItem={addItem}>
                {(viewblockState.settings.horizontalLines || []).map((horizontalLine) => (
                    <HorizontalLineComponent
                        key={horizontalLine.id}
                        horizontalLine={horizontalLine}
                        onUpdate={updateLine}
                        onDelete={() => onDelete(horizontalLine.id)}
                    />
                ))}
            </Carousel>
        </FormWrapper>
    );
};

export default HorizontalLineConfigurator;
